module.exports = __webpack_public_path__ + "img/11.e816153a.png";